import { post } from "@/utils/utils";

const applicationMarket = {
  state: {},
  mutations: {
    ADD_BELT() {},
    QUERY_BELT_LIST() {},
    EDIT_BELT() {},
    DEL_BELT() {},
    QUERY_BELT_TEMP_LIST() {},
    ADD_BELT_TEMP() {},
    OPERATION_TEMP() {}
  },
  actions: {
    operationTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/belt/editBeltTemplate`,
        name: "OPERATION_TEMP",
        params
      });
    },
    addBeltTemp({ commit }, params) {
      return post({
        commit,
        url: `/basic/belt/addBeltTemplate`,
        name: "ADD_BELT_TEMP",
        params
      });
    },
    queryBeltTempList({ commit }, params) {
      return post({
        commit,
        url: `/basic/belt/queryBeltTemplateList`,
        name: "QUERY_BELT_TEMP_LIST",
        params
      });
    },
    addBelt({ commit }, params) {
      return post({
        commit,
        url: `/basic/belt/add`,
        name: "ADD_BELT",
        params
      });
    },
    editBelt({ commit }, params) {
      return post({
        commit,
        url: `/basic/belt/edit`,
        name: "EDIT_BELT",
        params
      });
    },
    delBelt({ commit }, params) {
      return post({
        commit,
        url: `/basic/belt/del `,
        name: "DEL_BELT",
        params
      });
    },
    queryBeltList({ commit }, params) {
      return post({
        commit,
        url: `/basic/belt/list`,
        name: "QUERY_BELT_LIST",
        params
      });
    }
  }
};

export default applicationMarket;
